/**
 * @ngdoc Controller
 */

(function () {
    'use strict';

    angular.module('vrm.components')
        .controller('ClearAlarmModalController', ClearAlarmModalController);

    /* @ngInject */
    function ClearAlarmModalController($scope, close, target, callback, $stateParams, $state) {
        $scope.clearAlarm = function() {
            $.magnificPopup.close();
            callback();
        }

        $scope.cancel = function() {
            $.magnificPopup.close();
        }

        $scope.gotoAlarmRules = function() {
            $.magnificPopup.close();
            $state.go('base.installation.settings.alarms', {id: $stateParams.id});
        }

        return {
            close: close,
        };
    }
})();
